import React, { Component } from 'react';
import { css } from '@emotion/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import debounce from 'es6-promise-debounce';
import fetch from 'isomorphic-fetch';
import { FiMenu, FiX } from 'react-icons/fi';
import A from '../../Anchor/Anchor';
import Link from '../../Link/Link';
import Search from '../../Icons/Search';
import AsyncSelect from '../../../shared/AsyncSelect/AsyncSelect';
import Button from '../../Button/Button';
import CartMenu from './CartMenu/CartMenu';
import ProductAutocomplete from '../../ProductAutocomplete/ProductAutocomplete';
import api from '../../../../api';
import { showHeaderMenu } from '../../../../redux/modules/showHeaderMenu';
import Modal from '../Modal/Modal';
import './HeaderMenu.scss';
import { ga4Search } from '../../lib/ga4EnhancedEcommerce';
import { fkmxSearch } from '../../lib/farmakomMetrics';
import LoginIcon from '../../Icons/Login';
import { primary_s15_l20, primary_s98_l83 } from '../../lib/colors';
import lightOrDark from '../../SlickArrow/colorArrowFunction';
import LoginRegister from '../TopHeader/LoginRegister';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMegaMenuType: '',
      showMegaMenu: false,
      showCartMenu: false,
      showLogin: false,
      showCategoriesMenu: false,
    };
  }

  // GET CATEGORIES
  getCategories(type) {
    if (!type) {
      return [];
    }
    // Prodotti o Farmaci
    if (type === 'prodotti' || type === 'farmaci') {
      return this.props.categories.filter(category => category.type === type);
    }
    // TAG
    const tag = this.props.categoryTags.find(t => t.name === type);
    if (tag) {
      return tag.categories;
    }
    return;
  }

  getOptions = input => {
    const { endpoint, method, headers, body } = api.searchProductsByKeywords(
      input,
      1,
      4
    );

    const headersWithStoreId = {
      ...headers,
      storeid: this.props.storeId,
    };

    if (input.length > 1) {
      // GA4 USER SEARCH
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4Search(input);
      }

      // FKMX USER SEARCH
      if (this.props.hasFarmakomMetrics) {
        fkmxSearch(input);
      }

      return fetch(endpoint, { method, headers: headersWithStoreId, body })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.items.length === 4) {
            json.items = [
              {
                id: -1,
                name: 'Vedi tutti',
                searchKeywords: input,
              },

              ...json.items,
            ];
          }
          return {
            options: json.items.map(item => ({
              ...item,
              path: `/${item.type}/${item.categorySeoName}/${
                item.subcategorySeoName ? item.subcategorySeoName : '_'
              }/${encodeURIComponent(item.seoName)}`,
            })),
          };
        });
    }
    return Promise.resolve([]);
  };

  getOptionsDebounced = debounce(this.getOptions, 500);

  getOptionsDoofinder = input => {
    const {
      endpoint,
      method,
      headers,
      body,
    } = api.getProductsByKeywordsDoofinder(
      input,
      1,
      5,
      this.props.doofinderHashId
    );

    if (input.length > 1) {
      // GA4 USER SEARCH
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4Search(input);
      }

      // FKMX USER SEARCH
      if (this.props.hasFarmakomMetrics) {
        fkmxSearch(input);
      }

      return fetch(endpoint, { method, body })
        .then(response => {
          return response.json();
        })
        .then(json => {
          let options = json.results.map(result => ({
            id: result.id,
            image: result.image_link || result['image link'],
            name: result.title,
            path: (result.link || '').replace(this.props.siteUrl, ''),
            price: result.sale_price || result.price,
            listPrice: result.listprice,
          }));

          if (json.results.length >= 5) {
            options = [
              {
                id: -1,
                image: '',
                name: 'Vedi tutti',
                path: '',
                searchKeywords: input,
              },
              ...options,
            ];
          }

          options = [
            ...options,
            {
              id: -2,
              label: 'Powered by',
              sponsorName: 'Doofinder',
              sponsor: true,
              backgroundColor: 'black',
              searchKeywords: input,
            },
          ];

          return { options };
        })
        .catch(error => {
          console.error(error);
          this.getOptions(input);
        });
    }
    return Promise.resolve([]);
  };

  getOptionsDoofinderDebounced = debounce(this.getOptionsDoofinder, 500);

  // MENU
  toggleHeaderMenu = event => {
    event.preventDefault();
    this.closeAll();

    const { showHeaderMenu, headerMenuOpen } = this.props;

    showHeaderMenu(!headerMenuOpen);
  };

  // CART MENU
  toggleCartMenu = event => {
    event.preventDefault();
    this.closeAll();

    this.setState({
      showCartMenu: !this.state.showCartMenu,
    });
  };

  closeCartMenu = event => {
    this.setState({
      showCartMenu: false,
    });
  };

  // CLOSE ALL
  closeAll = event => {
    this.setState({
      showMegaMenu: false,
      selectedMegaMenuType: null,
      showCartMenu: false,
      showLogin: false,
      mobileCategory: null,
      mobileSubCategory: null,
    });
    this.props.showHeaderMenu(false);
  };

  // RENDER
  renderSearchBox = () => {
    return (
      <search className="search-box header-search">
        <AsyncSelect
          isHeader
          aria-label="Cerca prodotto"
          id="search-box"
          name="keyword-search"
          defaultOptions={[]}
          loadOptions={
            this.props.hasDoofinder
              ? this.getOptionsDoofinderDebounced
              : this.getOptionsDebounced
          }
          openOnClick={false}
          openOnFocus={false}
          autoload={false}
          onChange={product => {
            if (product.id > 0) {
              this.props.router.push(product.path);
            }
            if (product.id < 0) {
              this.props.router.push(`/ricerca/${product.searchKeywords}`);
            }
            this.props.showHeaderMenu(false);
          }}
          optionRenderer={product => (
            <ProductAutocomplete
              isDoofinder={this.props.hasDoofinder}
              product={product}
              primaryColor={this.props.primaryColor}
            />
          )}
          arrowRenderer={() => <Search />}
          filterOption={() => true}
          clearable={false}
          autosize={false}
          placeholder="Cerca per prodotto..."
          loadingPlaceholder="Caricamento..."
          searchPromptText="Digita il nome del prodotto"
        />
      </search>
    );
  };

  setMobileCategory = mobileCategory => {
    if (this.state.mobileCategory === mobileCategory) {
      this.setState({
        mobileCategory: null,
      });
    } else {
      this.setState({
        mobileCategory,
      });
    }
  };

  setMobileSubCategory = mobileSubCategory => {
    if (this.state.mobileSubCategory === mobileSubCategory) {
      this.setState({
        mobileSubCategory: null,
      });
    } else {
      this.setState({
        mobileSubCategory,
      });
    }
  };

  render() {
    const { showMegaMenu, showCartMenu } = this.state;

    const {
      primaryColor,
      secondaryColor,
      hasBlog,
      couponPageUrl,
      loghiTemplate,
      loginError,
      categoryTags,
      headerMenuOpen,
      facebookAppId,
      hasFacebookLogin,
      uiVariantMenu,
      headerMenuVersion,
      user,
      isAuthenticated,
      onLogin,
    } = this.props;

    const headerMenuStyle = css`
      &.container-wide.version-1 {
        height: 100%;
        width: 100%;
        max-width: 100%;
        @media screen and (max-width: 768px) {
          display: flex;
          justify-content: center;
          gap: 0px;
          padding-left: 15px;
          padding-right: 15px;
        }
        .center-header-mobile {
          margin-left: 0%;
          .search-box {
            .Select {
              .Select-control {
                background-color: #ffff;
                height: 38px;
                flex-direction: row;
                .Select-input input {
                  padding-left: 18px;
                }
                .Select-multi-value-wrapper > .Select-placeholder {
                  padding-left: 24px;
                  border: none;
                  @media screen and (max-width: 340px) {
                    position: absolute;
                    text-overflow: ellipsis;
                    display: block;
                    max-width: 87px;
                  }
                }

                .Select-arrow-zone {
                  background-color: ${primaryColor};
                  svg {
                    color: #ffff;
                  }
                }
              }
            }
          }
        }
        .d-flex {
          width: 100%;

          .left-header .open-categories .dropdown-categories {
            @media screen and (max-width: 992px) {
              display: none;
            }
          }
          .center-header-desktop {
            margin-left: 0%;
            .search-box {
              .Select {
                .Select-control {
                  background-color: #ffff;
                  height: 38px;
                  flex-direction: row;
                  .Select-multi-value-wrapper > .Select-placeholder {
                    padding-left: 20px;
                    border: none;
                    @media screen and (max-width: 340px) {
                      position: absolute;
                      text-overflow: ellipsis;
                      display: block;
                      max-width: 87px;
                    }
                    @media screen and (max-width: 992px) {
                      margin-left: 10px;
                      padding-left: 32px;
                    }
                  }

                  .Select-arrow-zone {
                    background-color: ${primaryColor};
                    svg {
                      color: #ffff;
                    }
                  }
                }
              }
            }
          }

          .right-header {
            display: flex;
            gap: 20px;
            @media screen and (max-width: 768px) {
              gap: 1rem;
            }
            a > .favorites > svg > path {
              fill: ${primaryColor};
            }

            a > .favorites-v1 {
              align-items: center;
              display: flex;
              align-items: center;
              gap: 8px;
              svg {
                width: 19px;
                height: 18px;
                color: ${primaryColor};
                @media screen and (max-width: 768px) {
                  width: 15px;
                  height: 14px;
                }
              }
              p {
                display: block;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                white-space: nowrap;
                margin-bottom: 0px;
                color: #222222;

                @media screen and (max-width: 992px) {
                  display: none;
                }
              }
            }
            .open-cart-menu > a > .cart {
              width: 100%;
              .badge {
                position: absolute;
                top: 0px;
                right: -9px;
                z-index: 1000;
              }
              p {
                color: #222222;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                @media screen and (max-width: 992px) {
                  display: none;
                }
              }
            }
          }
        }
      }
      &.container-wide.version-2 {
        max-width: 94%;
        height: 100%;
        padding: 0px;
        gap: 0px;
        @media screen and (max-width: 992px) {
          gap: 6px;
        }

        .center-header-mobile {
          width: 100%;
        }
        .d-flex {
          width: 100%;
          .center-header-desktop {
            width: 50%;
          }
          .search-box
            .Select
            .Select-control
            .Select-multi-value-wrapper
            .Select-placeholder {
            padding-left: 32px;
          }
        }
      }
      &.container-wide.version-2,
      &.container-wide.version-3 {
        .center-header-mobile {
          @media screen and (max-width: 992px) {
            margin-left: 0px;
          }
          .search-box {
            .Select {
              .Select-control {
                background-color: #f8f8f8;
                height: 38px;
                flex-direction: row-reverse;
                .Select-multi-value-wrapper > .Select-placeholder {
                  padding-left: 32px;
                  border: none;
                  @media screen and (max-width: 340px) {
                    position: absolute;

                    text-overflow: ellipsis;
                    display: block;
                    max-width: 87px;
                  }
                }
              }
            }
          }
        }
        .d-flex {
          width: 100%;
          height: 100%;
          .right-header {
            a > .favorites > svg > path {
              fill: ${secondaryColor};
            }
          }
          .left-header .open-categories .dropdown-categories {
            margin-right: 5px;
            margin-left: 0px;
            @media screen and (max-width: 992px) {
              gap: 3px;
            }
          }
        }
        &.container-wide.version-3 {
          height: 100%;
          padding: 0px;
          max-width: 94%;
          .d-flex {
            width: 100%;
            .search-box
              .Select
              .Select-control
              .Select-multi-value-wrapper
              .Select-placeholder {
              padding-left: 32px;
            }
          }
        }
      }
    `;

    const categoriesDropdownStyle = css`
      .container .mega-menu .categories-container {
        position: absolute;
        top: 0px;
        left: 113%;
        width: 100vw;
        height: 100vh;
      }
    `;

    const checkColor = lightOrDark(primaryColor);

    const bottomMenuStyle = css`
      &.variant-1 {
        .mobile-menu a.link {
          padding-top: 16px !important;
          padding-bottom: 16px;
        }

        .mobile-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          font-size: 13px;
          &:focus,
          &:hover,
          &.active {
            color: ${primaryColor};
            background-color: ${primary_s98_l83(secondaryColor)};
          }
        }
      }

      &.variant-2 {
        .desktop-menu a.link {
          margin: 0 10px;
          padding: 10px 9px;
        }
        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primaryColor};
          font-size: 13px;
          border-width: 1px;
          border-style: solid;
          border-color: ${primaryColor};

          &:focus,
          &:hover,
          &.active {
            color: #fff;
            background-color: ${primaryColor};
          }
        }
      }

      &.variant-3 {
        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primary_s15_l20(primaryColor)};
          font-size: 12px;
          text-transform: uppercase;

          &:focus,
          &:hover,
          &.active {
            color: ${primaryColor};
          }
        }

        .desktop-menu a.link {
          margin: 0 8px;

          &.active svg {
            transform: rotate(180deg);
            transition: all 0.3s ease-in-out;
          }

          svg {
            margin-left: 10px;
            transform: rotate(0);
            transition: all 0.3s ease-in-out;
          }
        }
      }

      .desktop-menu > a.link {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        &:first-of-type {
          margin-left: 0;
        }
        &:last-of-type {
          margin-right: 0;
        }
      }

      .mobile-menu > a.link {
        &:focus,
        &:hover {
          color: ${primaryColor};
        }
      }
    `;

    return (
      <div
        className={`header-menu ${showMegaMenu ? 'mega-menu-open' : ''}`}
        css={categoriesDropdownStyle}
      >
        <nav className="navbar navbar-expand-lg" role="navigation">
          {/* TOP MENU */}
          <div
            className={`top version-${headerMenuVersion}`}
            style={{
              backgroundColor: headerMenuVersion !== 1 ? '#ffff' : '#f8f8ff',
            }}
          >
            <div
              className={`container container-wide version-${headerMenuVersion}`}
              css={headerMenuStyle}
            >
              <div
                className={`d-flex flex-row align-items-center justify-content-between`}
              >
                <div className="left-header">
                  <Button
                    type="button"
                    className="navbar-toggler"
                    data-toggle="collapse"
                    data-target="#menu"
                    aria-expanded="false"
                    onClick={this.toggleHeaderMenu}
                    style={{ color: primaryColor }}
                  >
                    <span className="sr-only">Toggle navigation</span>
                    {headerMenuOpen ? <FiX /> : <FiMenu />}
                  </Button>
                  <Link
                    to="/"
                    className="navbar-brand"
                    activeClassName="active"
                  >
                    <ImageDispatcher
                      src={loghiTemplate.logoImage}
                      alt={`${this.props.siteName}, Vendita online di farmaci, prodotti per la cosmesi, per la salute e per l'igiene`}
                    />
                  </Link>
                </div>
                {!this.props.isMobile && (
                  <div className="hidden-mobile center-header-desktop">
                    <Modal categoryTags={categoryTags} />
                    {this.renderSearchBox()}
                  </div>
                )}

                <div className="right-header">
                  <CartMenu
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    showCartMenu={showCartMenu}
                    onToggleCartMenu={this.toggleCartMenu}
                    onCloseCartMenu={this.closeCartMenu}
                    onCloseAll={this.closeAll}
                    headerMenuVersion={headerMenuVersion}
                  />

                  {!!this.props.isMobile && (
                    <div className="mobile">
                      <LoginRegister
                        simple
                        user={user}
                        isAuthenticated={isAuthenticated}
                        onLogin={onLogin}
                        loginError={loginError}
                        facebookAppId={facebookAppId}
                        hasFacebookLogin={hasFacebookLogin}
                        primaryColor={primaryColor}
                      />
                    </div>
                  )}
                </div>
              </div>
              {this.props.isMobile && (
                <div className="center-header-mobile">
                  {this.renderSearchBox()}
                </div>
              )}
            </div>
          </div>

          {/* BOTTOM MENU */}
          <div
            className={`bottom-menu variant-${uiVariantMenu}`}
            css={bottomMenuStyle}
            style={{ backgroundColor: 'white' }}
          >
            <div
              className={`navbar-collapse collapse ${
                headerMenuOpen ? 'show' : ''
              } justify-between`}
              id="menu"
            >
              <div className="mobile-menu">
                {!!isAuthenticated && (
                  <div className="user-section">
                    <div className="container">
                      <Link
                        to="/profilo"
                        className="welcome-user"
                        onClick={this.closeAll}
                      >
                        <LoginIcon /> Ciao{' '}
                        {user && user.billing && user.billing.firstname}
                      </Link>
                    </div>
                  </div>
                )}
                {!!this.getCategories('prodotti').length && (
                  <>
                    <a
                      href="#"
                      className="link"
                      onClick={() => this.setMobileCategory('prodotti')}
                      activeClassName="active"
                      style={{
                        borderBottom:
                          this.state.mobileCategory === 'prodotti' ? 0 : '',
                      }}
                    >
                      <div className="container">Prodotti</div>
                    </a>
                    {this.state.mobileCategory === 'prodotti' &&
                      this.props.categories
                        .filter(cat => cat.type === 'prodotti')
                        .map(category => (
                          <>
                            <a
                              href="#"
                              className="link mobile-category"
                              activeClassName="active"
                            >
                              <div
                                onClick={() =>
                                  this.setMobileSubCategory(category.name)
                                }
                                className="container"
                                style={{ paddingLeft: 30, fontSize: 10 }}
                              >
                                {category.name}
                              </div>
                            </a>
                            {this.state.mobileCategory === 'prodotti' &&
                              this.state.mobileSubCategory === category.name &&
                              category.subcategories.map(subcategory => (
                                <Link
                                  to={`/prodotti/${category.seoName}/${subcategory.seoName}`}
                                  className="link mobile-category"
                                  onClick={this.closeAll}
                                  activeClassName="active"
                                >
                                  <div
                                    className="container"
                                    style={{ paddingLeft: 45, fontSize: 10 }}
                                  >
                                    {subcategory.name}
                                  </div>
                                </Link>
                              ))}
                          </>
                        ))}
                  </>
                )}
                {!!this.getCategories('farmaci').length && (
                  <>
                    <a
                      href="#"
                      className="link"
                      onClick={() => this.setMobileCategory('farmaci')}
                      activeClassName="active"
                      style={{
                        borderBottom:
                          this.state.mobileCategory === 'farmaci' ? 0 : '',
                      }}
                    >
                      <div className="container">Farmaci</div>
                    </a>
                    {this.state.mobileCategory === 'farmaci' &&
                      this.props.categories
                        .filter(cat => cat.type === 'farmaci')
                        .map(category => (
                          <>
                            <a
                              href="#"
                              className="link mobile-category"
                              activeClassName="active"
                            >
                              <div
                                onClick={() =>
                                  this.setMobileSubCategory(category.name)
                                }
                                className="container"
                                style={{ paddingLeft: 30, fontSize: 10 }}
                              >
                                {category.name}
                              </div>
                            </a>
                            {this.state.mobileCategory === 'farmaci' &&
                              this.state.mobileSubCategory === category.name &&
                              category.subcategories.map(subcategory => (
                                <Link
                                  to={`/prodotti/${category.seoName}/${subcategory.seoName}`}
                                  className="link mobile-category"
                                  onClick={this.closeAll}
                                  activeClassName="active"
                                >
                                  <div
                                    className="container"
                                    style={{ paddingLeft: 45, fontSize: 10 }}
                                  >
                                    {subcategory.name}
                                  </div>
                                </Link>
                              ))}
                          </>
                        ))}
                  </>
                )}
                {!!this.props.discounted.length && (
                  <Link
                    to="/prodotti-in-offerta"
                    className="link"
                    onClick={this.closeAll}
                  >
                    <div className="container">Offerte</div>
                  </Link>
                )}
                {!!hasBlog && (
                  <Link to="/blog" className="link" onClick={this.closeAll}>
                    <div className="container">Blog</div>
                  </Link>
                )}
                <Link
                  to="/pagine/contattaci"
                  className="link"
                  onClick={this.closeAll}
                >
                  <div className="container">Contatti</div>
                </Link>
                <Link
                  to="/pagine/servizi"
                  className="link"
                  onClick={this.closeAll}
                >
                  <div className="container">Servizi</div>
                </Link>
                {!!hasBlog && !!couponPageUrl && (
                  <A
                    className="link"
                    href={couponPageUrl}
                    onClick={this.closeAll}
                  >
                    <div className="container">Coupon</div>
                  </A>
                )}
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    storeId: state.store.data.storeId,
    categories: state.categories.data.categories,
    categoryTags: state.categories.data.tags,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    hasBlog: state.store.data.features.hasBlog,
    hasFacebookLogin: state.store.data.features.hasFacebookLogin,
    hasDoofinder: state.store.data.features.hasDoofinder,
    doofinderHashId: state.store.data.integrazioni.doofinder.hashId,
    couponPageUrl: state.store.data.funzionalita.couponPageUrl,
    loghiTemplate: state.store.data.loghiTemplate,
    loginError: state.user.error,
    headerMenuOpen: state.showHeaderMenu.headerMenuOpen,
    uiVariantMenu: state.store.data.uiVariants.menu,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    discounted: state.homeProducts.data.discounted,
  };
}

export default withRouter(
  connect(mapStateToProps, { showHeaderMenu })(HeaderMenu)
);
